import { appendQueryParamToUrl } from './redirect';

export const getCtaUrlWithCampaignId = (configCampaignId: string, url = '') => {
  const ctaUrl = new URL(url);

  // use campaignId in query params if exists
  const queryParams = new URLSearchParams(window.location.search);
  const queryParamCampaignId = queryParams.get('campaignId');
  if (queryParamCampaignId) {
    ctaUrl.searchParams.set('campaignId', queryParamCampaignId);
    return ctaUrl.toString();
  }

  // if no campaignId in query params, use campaignId on cta url if exists
  const ctaCampaignId = ctaUrl.searchParams.get('campaignId');
  if (ctaCampaignId) return url;

  // if no campaignId on cta url or in query params, use the campaignId from the config file
  return appendQueryParamToUrl(url, `campaignId=${configCampaignId}`);
};
